import React from 'react';
import PropTypes from 'prop-types';
import FormCheckbox from 'components/FormCheckbox';

export default function PDFOptionsPanel({ catalog, values, onChange }) {
  return (
    <div className="print-options-panels">
      {catalog.groups.map(group => (
        <aside
          key={group.id}
          className="print-filters"
          aria-label={group.label}
        >
          <div className="print-filters__title">{group.label}</div>
          {group.options
            .filter(option => option.available !== false)
            .map(option => {
              const value = values[option.key] ?? option.default;
              if (option.type === 'boolean')
                return (
                  <FormCheckbox
                    key={option.key}
                    label={option.label}
                    checked={value}
                    onChange={() => onChange(option.key, !value)}
                  />
                );
              if (option.type === 'choice')
                return (
                  <div key={option.key} className="print-filters__field">
                    <label htmlFor={`pdf-option-${option.key}`}>
                      {option.label}
                    </label>
                    <select
                      id={`pdf-option-${option.key}`}
                      value={JSON.stringify(value)}
                      onChange={event =>
                        onChange(option.key, JSON.parse(event.target.value))
                      }
                    >
                      {option.choices.map(choice => (
                        <option
                          key={JSON.stringify(choice.value)}
                          value={JSON.stringify(choice.value)}
                        >
                          {choice.label}
                        </option>
                      ))}
                    </select>
                  </div>
                );
              return (
                <fieldset key={option.key} className="border-0 p-0">
                  <legend className="visually-hidden">{option.label}</legend>
                  {option.choices.map(choice => (
                    <FormCheckbox
                      key={JSON.stringify(choice.value)}
                      label={choice.label}
                      checked={value.includes(choice.value)}
                      onChange={() =>
                        onChange(
                          option.key,
                          value.includes(choice.value)
                            ? value.filter(item => item !== choice.value)
                            : [...value, choice.value]
                        )
                      }
                    />
                  ))}
                </fieldset>
              );
            })}
        </aside>
      ))}
    </div>
  );
}
PDFOptionsPanel.propTypes = {
  catalog: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
